import dynamic from "next/dynamic";

const DynamicConfirmDeleteModal = dynamic(
  () =>
    import("modules/common/components/ConfirmDeleteModal").then(
      (mod) => mod.ConfirmDeleteModal
    ),
  {
    loading: () => <></>,
  }
);

export default DynamicConfirmDeleteModal;
